import React from 'react';
import happyWithLogo from 'images/characters/happy-with-logo.svg';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import { LBButton } from '@linearb/buzz';

const InvitationSentSuccessfullyModal = ({ name = '' }) => {
  return (
    <Flex
      justify='center'
      direction='column'
      items='center'
      width='100%'
      height='100%'
    >
      <img src={happyWithLogo} alt='' />
      <Text size='x-x-x-large' pt='2rem' weight='300'>
        Success!
      </Text>
      <Text size='x-large' pt='2rem' pb='2rem' weight='400'>
        {`You just invited ${name} to LinearB`}
      </Text>
      <Padding t='medium' b='large'>
        <LBButton
          onClick={() => {
            window.location = '/settings/users?isOrgSettings=true';
          }}
        >
          invite more people
        </LBButton>
      </Padding>
    </Flex>
  );
};

export default InvitationSentSuccessfullyModal;
